/**
 * @generated SignedSource<<7687d6a038a81bd5a15174dd6aca676d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef$data = {
  readonly id: string;
  readonly name: string;
  readonly priority: {
    readonly iconUrl: AGG$URL | null | undefined;
    readonly id: string;
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"priority_issueFieldPriorityReadviewFull_PriorityReadView">;
  readonly " $fragmentType": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef";
};
export type priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef$key = {
  readonly " $data"?: priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "priority_issueFieldPriorityReadviewFull_PriorityReadView"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "concreteType": "JiraPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "name": "iconUrl"
        }
      ]
    }
  ],
  "type": "JiraPriorityField"
};
})();

(node as any).hash = "5c87c8c190fde008c7c6d3bde3e475a1";

export default node;
